import { C as b } from "./component-C-rYG68G.js";
import { T as g } from "./events-CnaEWcY_.js";
import { d as x, r as C, e as u, f as v } from "./utilities-BYG85iVY.js";
class y extends b {
  #t = null;
  #e = !1;
  #o = !1;
  #n = null;
  #s = null;
  #r = null;
  connectedCallback() {
    (super.connectedCallback(),
      this.#i(),
      document.addEventListener(g.cartUpdate, this.#c),
      (this.#r = () => {
        const e = window.liquidAjaxCart?.cart?.item_count;
        typeof e == "number" && this.#i(e);
      }),
      document.addEventListener("liquid-ajax-cart:init", this.#r),
      this.#p(),
      this.#u());
  }
  disconnectedCallback() {
    (super.disconnectedCallback(),
      document.removeEventListener(g.cartUpdate, this.#c),
      this.#r && (document.removeEventListener("liquid-ajax-cart:init", this.#r), (this.#r = null)),
      this.#n &&
        this.#s &&
        (this.#n.removeEventListener("recommendations-json-loaded", this.#s), (this.#s = null)),
      (this.#n = null),
      this.#t && (this.#t.disconnect(), (this.#t = null)));
  }
  #u() {
    const e = this.closest(".cart-upsells");
    if (!e) return;
    const t = () => this.querySelector("carousel-embla"),
      r = () => {
        const n = t(),
          s = n?.embla,
          i = e.querySelector(".cart-upsells-nav__prev"),
          o = e.querySelector(".cart-upsells-nav__next");
        if (!s || !i || !o) return;
        if (n?.dataset?.loop !== "false") {
          ((i.disabled = !1), (o.disabled = !1));
          return;
        }
        const c = typeof s.selectedSnap == "function" ? s.selectedSnap() : 0,
          m =
            (typeof s.scrollSnapList == "function" && s.scrollSnapList().length) ||
            (typeof s.slideNodes == "function" && s.slideNodes().length) ||
            0;
        ((i.disabled = c <= 0), (o.disabled = m > 0 && c >= m - 1));
      };
    e.addEventListener("click", (n) => {
      const i = n.target.closest?.(".cart-upsells-nav__prev, .cart-upsells-nav__next");
      if (!i) return;
      n.preventDefault();
      const a = t()?.embla;
      a &&
        (i.classList.contains("cart-upsells-nav__prev")
          ? typeof a.goToPrev == "function"
            ? a.goToPrev()
            : typeof a.scrollPrev == "function" && a.scrollPrev()
          : typeof a.goToNext == "function"
            ? a.goToNext()
            : typeof a.scrollNext == "function" && a.scrollNext());
    });
    let p = 0;
    const l = () => {
      const s = t()?.embla;
      if (s) {
        (r(), s.on("select", r), s.on("reinit", r));
        return;
      }
      p++ < 20 && setTimeout(l, 150);
    };
    l();
  }
  #i(e) {
    const t = this.closest(".cart-upsells");
    if (!t || (typeof e != "number" && !window.liquidAjaxCart?.cart)) return;
    if (
      (typeof e == "number"
        ? e
        : (window.liquidAjaxCart?.cart?.item_count ??
          window.liquidAjaxCart?.cart?.items?.length ??
          0)) <= 0
    ) {
      ((t.style.display = "none"), (this.#o = !0));
      return;
    }
    this.#o && ((t.style.display = ""), (this.#o = !1));
  }
  #c = (e) => {
    const t = e?.detail?.data?.itemCount ?? e?.detail?.resource?.item_count;
    this.#i(typeof t == "number" ? t : void 0);
  };
  #p() {
    const e = this.querySelector("product-recommendations");
    if (e && ((this.#n = e), e.dataset.carouselProcessed !== "true")) {
      if (
        ((this.#s = (t) => {
          if (this.#e) return;
          const { products: r } = t.detail;
          C(
            () => {
              this.#l(e, r);
            },
            { timeout: 2e3 }
          );
        }),
        e.addEventListener("recommendations-json-loaded", this.#s),
        e.dataset.recommendationsPerformed === "true" && e.dataset.recommendationsJson,
        (this.#t = new MutationObserver(() => {
          if (this.#e) return;
          if (
            e.dataset.recommendationsPerformed === "true" &&
            e.dataset.recommendationsJson === "true" &&
            e.innerHTML.trim().length === 0 &&
            e.dataset.recommendationsProducts
          )
            try {
              const r = JSON.parse(e.dataset.recommendationsProducts);
              this.#l(e, r);
              return;
            } catch (r) {
              console.error("Error parsing stored recommendations JSON:", r);
            }
          e.innerHTML.trim().length > 0 &&
            e.dataset.recommendationsPerformed === "true" &&
            e.dataset.recommendationsJson !== "true" &&
            this.#d(e);
        })),
        this.#t.observe(e, {
          childList: !0,
          subtree: !0,
          attributes: !0,
          attributeFilter: ["data-recommendations-performed", "data-recommendations-json"],
        }),
        e.dataset.recommendationsPerformed === "true" &&
          e.dataset.recommendationsJson === "true" &&
          e.dataset.recommendationsProducts)
      )
        try {
          const t = JSON.parse(e.dataset.recommendationsProducts);
          this.#l(e, t);
          return;
        } catch (t) {
          console.error("Error parsing stored recommendations JSON:", t);
        }
      e.dataset.recommendationsPerformed === "true" && e.innerHTML.trim().length > 0 && this.#d(e);
    }
  }
  async #l(e, t) {
    const r = e.querySelector(".cart-upsells-loading");
    if ((r && r.remove(), this.#e || !t)) {
      ((this.#e = !0), (e.dataset.carouselProcessed = "true"));
      return;
    }
    if (t.length === 0) {
      ((this.#e = !0), (e.dataset.carouselProcessed = "true"));
      const d = e.closest(".cart-upsells");
      d && (d.style.display = "none");
      return;
    }
    const p = this.#f(),
      n = t
        .filter((d) => !p.includes(String(d.id)))
        .map((d) => {
          const h = this.#m(d);
          return d?.available !== !1 && !!h?.id ? { product: d, variant: h } : null;
        })
        .filter(Boolean);
    if (n.length === 0) {
      ((this.#e = !0), (e.dataset.carouselProcessed = "true"));
      const d = e.closest(".cart-upsells");
      d && (d.style.display = "none");
      return;
    }
    const s = document.createDocumentFragment(),
      i = [];
    for (const d of n.slice(0, 8)) {
      const h = document.createElement("div");
      h.className = "carousel-slide shrink-0";
      const w = this.#h(d.product, d.variant);
      ((h.innerHTML = w), i.push(h), s.appendChild(h));
    }
    if (i.length === 0) {
      ((this.#e = !0), (e.dataset.carouselProcessed = "true"));
      return;
    }
    const o = document.createElement("carousel-embla");
    ((o.className = "carousel cart-upsells-carousel"),
      o.setAttribute("data-loop", "false"),
      o.setAttribute("data-align", "start"),
      o.setAttribute("data-slides-to-scroll", "1"));
    const a = document.createElement("div");
    ((a.className = "overflow-hidden"), a.setAttribute("ref", "viewport"));
    const c = document.createElement("div");
    for (c.className = "flex gap-5", c.setAttribute("ref", "container"); s.firstChild; )
      c.appendChild(s.firstChild);
    a.appendChild(c);
    const m = document.createElement("div");
    ((m.className = "carousel-container relative"), m.appendChild(a));
    const f = document.createElement("div");
    ((f.className = "carousel-arrows"),
      (f.innerHTML = `
      <button ref="prev" type="button" class="carousel-arrow carousel-arrow-previous" aria-label="${u(this.#a("general.previous"))}">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m15 18-6-6 6-6"/></svg>
      </button>
      <button ref="next" type="button" class="carousel-arrow carousel-arrow-next" aria-label="${u(this.#a("general.next"))}">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg>
      </button>
    `),
      m.appendChild(f),
      o.appendChild(m),
      (e.innerHTML = ""),
      e.appendChild(o),
      (this.#e = !0),
      (e.dataset.carouselProcessed = "true"),
      this.#t && (this.#t.disconnect(), (this.#t = null)));
  }
  #m(e) {
    const t = Array.isArray(e?.variants) ? e.variants : [];
    return t.find((r) => r?.available !== !1) || t[0] || null;
  }
  #h(e, t) {
    if (!t?.id) return "";
    const r = e.featured_image || e.images?.[0],
      p = t?.price || e.price || 0,
      l = t?.compare_at_price || e.compare_at_price || null,
      n = r?.startsWith("//") ? `https:${r}` : r || "",
      s = e.url || `/products/${e.handle}`,
      o =
        l && l > p
          ? `
        <div class="flex items-center gap-x-2">
          <span class="text-xs text-gray-500 line-through">${v(l)}</span>
          <span class="text-sm font-semibold">${v(p)}</span>
        </div>
      `
          : `<div class="text-sm font-semibold">${v(p)}</div>`,
      a = `
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="M12 5v14" />
        <path d="M5 12h14" />
      </svg>
    `,
      c = this.#a("cart.upsells.add_to_cart");
    return `
      <div class="product-card-compact cart-upsell-item flex flex-col gap-2">
        <div class="grid grid-cols-[50px_1fr] gap-2 items-center">
          <a href="${u(s)}" class="block">
            <div class="relative overflow-hidden rounded bg-gray-100">
              ${n ? `<img src="${u(n)}" alt="${u(e.title)}" class="w-12.5 h-12.5 object-cover rounded" loading="lazy" width="50" height="50">` : ""}
            </div>
          </a>
          <div class="min-w-0 flex flex-col gap-0.5">
            <a href="${u(s)}" class="text-sm font-medium no-underline text-inherit hover:underline line-clamp-2">
              ${u(e.title)}
            </a>
            ${o}
          </div>
        </div>
        <ajax-cart-product-form class="block">
          <form class="product-form-compact" action="/cart/add" method="post" enctype="multipart/form-data" novalidate>
            <input type="hidden" name="id" value="${t.id}">
            <button type="submit" name="add" class="button button-outline button-sm w-full cart-upsell-add" aria-label="${u(c)}: ${u(e.title)}">
              <span class="button-icon" aria-hidden="true">${a}</span>
              <span class="button-label">${u(c)}</span>
              <span class="button-loader hidden w-4 h-4">
                <svg class="animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-hidden="true">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
              </span>
            </button>
            <div data-ajax-cart-errors="form" class="text-xs text-red-600 mt-1 empty:hidden"></div>
          </form>
        </ajax-cart-product-form>
      </div>
    `;
  }
  #f() {
    return window.liquidAjaxCart?.cart?.items
      ? window.liquidAjaxCart.cart.items.map((e) => String(e.product_id))
      : [];
  }
  #a(e) {
    return (
      {
        "cart.upsells.add_to_cart":
          window.Theme?.translations?.products?.addToCart || "In den Warenkorb",
        "products.product.sold_out": window.Theme?.translations?.products?.soldOut || "Ausverkauft",
        "general.previous": window.Theme?.translations?.accessibility?.previous || "Previous",
        "general.next": window.Theme?.translations?.accessibility?.next || "Next",
      }[e] || e
    );
  }
  #d(e) {
    if (this.#e) return;
    const t = e.querySelector(".grid");
    if (!t) {
      ((this.#e = !0), (e.dataset.carouselProcessed = "true"));
      return;
    }
    const r = Array.from(t.querySelectorAll("a[href*='/products/'], .product-card"));
    if (r.length === 0) {
      ((this.#e = !0), (e.dataset.carouselProcessed = "true"));
      return;
    }
    const p = r.map((a) => {
        const c = document.createElement("div");
        return ((c.className = "carousel-slide shrink-0"), c.appendChild(a), c);
      }),
      l = document.createElement("carousel-embla");
    ((l.className = "carousel cart-upsells-carousel"),
      l.setAttribute("data-loop", "false"),
      l.setAttribute("data-align", "start"),
      l.setAttribute("data-slides-to-scroll", "1"));
    const n = document.createElement("div");
    ((n.className = "overflow-hidden"), n.setAttribute("ref", "viewport"));
    const s = document.createElement("div");
    ((s.className = "flex gap-5"),
      s.setAttribute("ref", "container"),
      p.forEach((a) => s.appendChild(a)),
      n.appendChild(s));
    const i = document.createElement("div");
    ((i.className = "carousel-container relative"), i.appendChild(n));
    const o = document.createElement("div");
    ((o.className = "carousel-arrows"),
      (o.innerHTML = `
      <button ref="prev" type="button" class="carousel-arrow carousel-arrow-previous" aria-label="${u(this.#a("general.previous"))}">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m15 18-6-6 6-6"/></svg>
      </button>
      <button ref="next" type="button" class="carousel-arrow carousel-arrow-next" aria-label="${u(this.#a("general.next"))}">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 18 6-6-6-6"/></svg>
      </button>
    `),
      i.appendChild(o),
      l.appendChild(i),
      (e.innerHTML = ""),
      e.appendChild(l),
      (this.#e = !0),
      (e.dataset.carouselProcessed = "true"),
      this.#t && (this.#t.disconnect(), (this.#t = null)));
  }
}
x("cart-upsells", y);
